import OutletIcon from "@ancon/wildcat-ui/shared/icons/storefront-outline.svg";
import BackIcon from "@ancon/wildcat-ui/shared/icons/arrow-back-long.svg";
import clsx from "clsx";

import styles from "./NavbarOutletSearch.module.scss";
import Button from "../support/Button";
import BodyText from "../support/BodyText";

type NavbarSearchProps = {
  isInNavBar?: boolean;
};

export default function NavbarOutletSearch({
  isInNavBar = true,
}: NavbarSearchProps) {
  const isWhiteLabeled = true;

  function getLeftAccessory() {
    return (
      <>
        <OutletIcon />
        <BackIcon />
      </>
    );
  }

  return (
    <Button
      variant="secondary"
      className={clsx(styles.container, {
        [styles.navBarSearch]: isInNavBar,
        [styles.outletDetailsPage]: true,
        [styles.whiteLabeled]: isWhiteLabeled,
        [styles.companyDashboard]: isWhiteLabeled,
        [styles.hasPreOrderCheckout]: false,
      })}
      outlined={!isInNavBar}
    >
      {getLeftAccessory()}
      <BodyText as="span">{"Outlet Name"}</BodyText>
    </Button>
  );
}
